import React, { FC, Fragment, useEffect, useState } from 'react';
import styles from './student-selector.module.css';

// Components
import ToggleButton from '../toggle-button/toggle-button';

// Helpers
import { getFirstAndSecondName } from '../../helpers/string-format-helper';

const StudentSelector: FC<{
  classrooms: ClassroomStudents[];
  handleStudentChange: (
    selectedClassrooms: number[],
    selectedStudents: number[]
  ) => void;
  initialClassrooms?: number[];
  initialStudents?: number[];
  lockClassroomSelection?: boolean;
  hideStudentSelection?: boolean;
}> = ({
  classrooms,
  handleStudentChange,
  initialClassrooms,
  initialStudents,
  lockClassroomSelection,
  hideStudentSelection
}) => {
    const [selectedClassrooms, setSelectedClassrooms] = useState<number[]>(
      initialClassrooms || []
    );
    const toogleClassroomSelected = (id: number) => {
      let newSelecteds = [];
      const isSelected = selectedClassrooms.includes(id);

      if (isSelected) {
        newSelecteds = selectedClassrooms.filter((classroom) => classroom !== id);

        const classroom = classrooms.find((classroom) => classroom.id === id);
        const students = classroom.students.map((student) => student.id);

        const newSelectedStudents = selectedStudents.filter(
          (selectedStudent) => !students.includes(selectedStudent)
        );

        setSelectedStudents(newSelectedStudents);
      } else {
        newSelecteds = selectedClassrooms.concat([id]);
      }

      setSelectedClassrooms(newSelecteds);
    };

    const [selectedStudents, setSelectedStudents] = useState<number[]>(
      initialStudents || []
    );
    const toogleStudentSelected = (id: number) => {
      let newSelecteds = [];
      const isSelected = selectedStudents.includes(id);

      if (isSelected) {
        newSelecteds = selectedStudents.filter((classroom) => classroom !== id);
      } else {
        newSelecteds = selectedStudents.concat([id]);
      }

      setSelectedStudents(newSelecteds);
    };

    const selectAllClassrooms = () => {
      const newClassroomsSelected = classrooms.map((classroom) => classroom.id);

      setSelectedClassrooms(newClassroomsSelected);
    };

    const selectAllStudents = () => {
      const newStudentsSelected = [];

      classrooms.forEach((classroom) => {
        const classroomIsSelected =
          selectedClassrooms.indexOf(classroom.id) !== -1;

        if (classroomIsSelected) {
          return classroom.students.map((student) =>
            newStudentsSelected.push(student.id)
          );
        }

        return null;
      });

      setSelectedStudents(newStudentsSelected);
    };

    const [allClassroomsSelected, setAllClassroomsSelected] = useState(false);
    const [allStudentsSelected, setAllStudentsSelected] = useState(false);
    useEffect(() => {
      handleStudentChange(selectedClassrooms, selectedStudents);

      const allClassroomsSelected =
        selectedClassrooms.length === classrooms.length;
      setAllClassroomsSelected(allClassroomsSelected);

      let studentsLength = 0;
      classrooms.forEach((classroom) => {
        if (selectedClassrooms.includes(classroom.id, 0))
          studentsLength = studentsLength + classroom.students.length;
      });

      const allStudentsSelected = selectedStudents.length === studentsLength;
      setAllStudentsSelected(allStudentsSelected);
    }, [selectedClassrooms, selectedStudents]); // eslint-disable-line react-hooks/exhaustive-deps

    const renderClassrooms = () => {
      let items: any[];
      items = classrooms.map((classroom) => {
        if (classroom.students.length === 0) return null;

        const isSelected = selectedClassrooms.includes(classroom.id);

        return (
          <ToggleButton
            value={classroom.name}
            selected={isSelected}
            key={classroom.id}
            onSelected={() => toogleClassroomSelected(classroom.id)}
          />
        );
      });

      return items;
    };

    const renderStudents = () => {
      const elements = [];

      if (selectedClassrooms.length > 0) {
        const sortArray = classrooms.map(c => c.id).filter(cId => selectedClassrooms.includes(cId));
        for (let idx = 0; idx < sortArray.length; idx++) {
          const classroomIndex = classrooms.findIndex(
            (classroom) => classroom.id === sortArray[idx]
          );
          const classroom = classrooms[classroomIndex];

          classroom.students.length > 0 &&
            elements.push(
              <div key={idx} className={styles.classroomSelected}>
                {!lockClassroomSelection && <h3>{classroom.name}</h3>}
                <div className={styles.classroomStudentList}>
                  {classroom.students.map((student) => {
                    const isSelected = selectedStudents.includes(student.id);

                    return (
                      <ToggleButton
                        value={getFirstAndSecondName(student.name)}
                        selected={isSelected}
                        key={student.id}
                        onSelected={() => toogleStudentSelected(student.id)}
                      />
                    );
                  })}
                </div>
              </div>
            );
        }
      } else {
        elements.push(
          <p key={0}>
            Selecione pelo menos uma turma para poder selecionar os alunos.
          </p>
        );
      }

      return elements;
    };

    const renderSelectAllClassrooms = () => {
      if (lockClassroomSelection) return null;

      return !allClassroomsSelected ? (
        <p onClick={selectAllClassrooms}>selecionar todos</p>
      ) : (
        <p
          onClick={() => {
            setSelectedClassrooms([]);
            setSelectedStudents([]);
          }}
        >
          desselecionar todos
        </p>
      );
    };

    return (
      <div className={styles.studentSelector}>
        <div className={styles.titleContainer}>
          {lockClassroomSelection ? (
            <h2>Turma {classrooms[0].name}</h2>
          ) : (
            <h2>Selecionar turmas:</h2>
          )}
          {renderSelectAllClassrooms()}
        </div>
        {!lockClassroomSelection && (
          <div className={styles.classroomButtonsContainer}>
            {renderClassrooms()}
          </div>
        )}
        {!hideStudentSelection && (
          <Fragment>
            <div className={styles.titleContainer}>
              <h2>Selecionar alunos:</h2>
              {selectedClassrooms.length > 0 && (
                <Fragment>
                  {!allStudentsSelected ? (
                    <p onClick={selectAllStudents}>selecionar todos</p>
                  ) : (
                    <p onClick={() => setSelectedStudents([])}>desselecionar todos</p>
                  )}
                </Fragment>
              )}
            </div>
            <div className={styles.studentListContainer}>{renderStudents()}</div>
          </Fragment>
        )
        }
      </div>
    );
  };

export default StudentSelector;
